import { render, staticRenderFns } from "./SignedInUser.vue?vue&type=template&id=2667f7c0&"
import script from "./SignedInUser.vue?vue&type=script&lang=js&"
export * from "./SignedInUser.vue?vue&type=script&lang=js&"
import style0 from "./SignedInUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports